import fp from 'lodash/fp';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, lifecycle, renderComponent, withHandlers, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { isTeamManager } from '../../../../../services';
import { businessActions, businessCurrentTeamSelector, businessSelector, businessTeamsSelector } from '../../../../../state/modules/business';
import { currentUserIndustry, currentUserSelector } from '../../../../../state/modules/user';
import Loading from '../../../loading';
import EditableTrainingPlans from './editable-training-plans';

const TeamTrainingPlans = ({
  teamTrainingPlans,
  getData,
  saveCpdCategorys,
  initBusinessTaskStack,
  businessTaskStack
}) => (
    <Grid>
      <Row>
        <Col md={12}>
          <h2>
            Team training plans
          </h2>
        </Col>
      </Row>
      <Row>
        <form>
          <EditableTrainingPlans
            entityName='team'
            taskStack={businessTaskStack}
            initTaskStack={initBusinessTaskStack}
            saveCpdCategorys={saveCpdCategorys}
            entityTrainingPlans={teamTrainingPlans}
            getData={getData} />
        </form>
      </Row>
    </Grid>
  );

const TeamTrainingPlan = compose(
  lifecycle({
    componentDidMount() {
      const {
        isTeamManager,
        getTeam
      } = this.props;
      getTeam(isTeamManager.businessId, isTeamManager.businessTeamId)
    }
  }),
  branch(
    ({ isFetchingTeamsWithStats, businessTeam }) => isFetchingTeamsWithStats || !businessTeam,
    renderComponent(Loading)
  ),
  withProps(
    ({ businessTeam }) => ({
      teamTrainingPlans: fp.map(
        ({ team, cpdCategorys, industryBusinessTeam }) => ({
          entity: team,
          cpdCategorys: fp.map(
            aoa => ({
              ...aoa,
              entityId: aoa.businessTeamId
            })
          )(cpdCategorys),
          industry: fp.first(industryBusinessTeam)
        })
      )([businessTeam.stats]),
      teamMemberTrainingPlans: fp.map(
        ({ user, cpdCategorys, industryUser }) => ({
          entity: {
            ...user,
            name: `${user.firstName} ${user.lastName}`
          },
          cpdCategorys: fp.map(
            aoa => ({
              ...aoa,
              entityId: aoa.userId
            })
          )(cpdCategorys),
          industry: industryUser
        })
      )(businessTeam.members)
    })
  ),
  withHandlers({
    getData: ({ getTeam, isTeamManager }) => () => getTeam(isTeamManager.businessId, isTeamManager.businessTeamId),
    saveCpdCategorys: ({ saveTeamTrainingPlan, business, currentUser, currentUserIndustry }) => ({ updatedIndustry, cpdCategorys, entity }) => {
      saveTeamTrainingPlan({
        cpdCategorys: fp.map(
          aoa => ({
            ...aoa,
            businessTeamId: aoa.entityId
          })
        )(cpdCategorys),
        businessId: business.id,
        businessTeamId: entity.id,
        userId: currentUser.id,
        industryId: currentUserIndustry.id,
        industry: updatedIndustry
      })
    },
    saveMemberCpdCategorys: ({ saveUserCpdCategorys, business, currentUserIndustry }) => ({ updatedIndustry, industry, cpdCategorys, entity }) => {
      saveUserCpdCategorys({
        cpdCategorys: fp.map(
          aoa => ({
            ...aoa,
            userId: aoa.entityId
          })
        )(cpdCategorys),
        businessId: business.id,
        industryId: currentUserIndustry.id,
        industry: updatedIndustry,
        userId: entity.id
      })
    }
  })
)(
  ({
    saveCpdCategorys,
    saveMemberCpdCategorys,
    teamTrainingPlans,
    teamMemberTrainingPlans,
    getData,
    initBusinessTaskStack,
    initBusinessUserTaskStack,
    businessTaskStack,
    businessUserTaskStack
  }) => (
      <Grid>
        <Row>
          <Col md={12}>
            <h2>
              Team training plan
          </h2>
          </Col>
        </Row>
        <Row>
          <form>
            <EditableTrainingPlans
              entityName='team'
              taskStack={businessTaskStack}
              initTaskStack={initBusinessTaskStack}
              saveCpdCategorys={saveCpdCategorys}
              entityTrainingPlans={teamTrainingPlans}
              getData={getData} />
          </form>
        </Row>
        <Row>
          <Col md={12}>
            <h2>
              Team Member training plans
          </h2>
          </Col>
        </Row>
        <Row>
          <form>
            <EditableTrainingPlans
              entityName='member'
              taskStack={businessUserTaskStack}
              initTaskStack={initBusinessUserTaskStack}
              saveCpdCategorys={saveMemberCpdCategorys}
              entityTrainingPlans={teamMemberTrainingPlans}
              getData={getData} />
          </form>
        </Row>
      </Grid>
    )
)

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  businessTeams: businessTeamsSelector(state),
  businessTeam: businessCurrentTeamSelector(state),
  isFetchingTeamsWithStats: state.business.team.isFetchingTeamsWithStats,
  currentUser: currentUserSelector(state),
  currentUserIndustry: fp.first(currentUserIndustry(state)),
  businessTaskStack: state.business.taskStack,
  businessUserTaskStack: state.business.user.taskStack
})

const mapDispatchToProps = (dispatch) => ({
  getTeams: bindActionCreators(businessActions.business.team.getTeams, dispatch),
  getTeam: bindActionCreators(businessActions.business.team.getTeam, dispatch),
  saveTeamTrainingPlan: bindActionCreators(businessActions.business.team.setTeamTrainingPlan, dispatch),
  saveUserCpdCategorys: bindActionCreators(businessActions.business.user.setCpdCategorys, dispatch),
  initBusinessTaskStack: bindActionCreators(businessActions.business.initTaskStack, dispatch),
  initBusinessUserTaskStack: bindActionCreators(businessActions.business.user.initTaskStack, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ currentUser, business }) => ({
      isTeamManager: isTeamManager(currentUser, business)
    }),
  ),
  branch(
    ({ isTeamManager }) => isTeamManager,
    renderComponent(TeamTrainingPlan)
  ),
  lifecycle({
    componentDidMount() {
      const {
        business,
        getTeams
      } = this.props;
      getTeams(business.id, {})
    }
  }),
  branch(
    ({ isFetchingTeamsWithStats, businessTeams }) => isFetchingTeamsWithStats || !businessTeams,
    renderComponent(Loading)
  ),
  withProps(
    ({ businessTeams }) => ({
      teamTrainingPlans: fp.map(
        ({ team, cpdCategorys, industryBusinessTeam }) => ({
          entity: team,
          cpdCategorys: fp.map(
            aoa => ({
              ...aoa,
              entityId: aoa.businessTeamId
            })
          )(cpdCategorys),
          industry: fp.first(industryBusinessTeam)
        })
      )(businessTeams.businessTeams)
    })
  ),
  withHandlers({
    getData: ({ getTeams, business }) => () => getTeams(business.id, {}),
    saveCpdCategorys: ({ saveTeamTrainingPlan, business, currentUser, currentUserIndustry }) => ({ updatedIndustry, industry, cpdCategorys, entity }) => {
      saveTeamTrainingPlan({
        cpdCategorys: fp.map(
          aoa => ({
            ...aoa,
            businessTeamId: aoa.entityId
          })
        )(cpdCategorys),
        businessId: business.id,
        businessTeamId: entity.id,
        userId: currentUser.id,
        industryId: currentUserIndustry.id,
        industry: updatedIndustry
      })
    }
  })
)(TeamTrainingPlans);


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/team-training-plans.js